import * as jsonPatch from 'fast-json-patch';
import type ReplicantMigrator from '../ReplicantMigrator';
import type SB from '../SchemaBuilder';

/**
 * Migrate and fill schema defaults to state. Mutates `entry`.
 *
 * @returns list of state changes made while filling defaults.
 */
export function migrateAndFillDefaults<TState>(
    config: { migrator: ReplicantMigrator; stateSchema: SB.Schema<TState> },
    entry: { state: TState; version: number },
): jsonPatch.Operation[] {
    // Migrate entry.
    const latestVersion = config.migrator.getLatestVersion();
    if (entry.version < latestVersion) {
        for (let migrationId = entry.version; migrationId < latestVersion; migrationId++) {
            config.migrator.applyMigration(entry.state, migrationId);
        }

        entry.version = latestVersion;
    }

    // Apply any schema defaults to the state.
    const stateFillDefaultsDiff: jsonPatch.Operation[] = [];
    const stateWithDefaults = config.stateSchema.tryValidateAndFillDefaults(entry.state);
    if (stateWithDefaults !== null) {
        stateFillDefaultsDiff.push(...(jsonPatch.compare(entry.state as Object, stateWithDefaults as Object) || []));
        entry.state = stateWithDefaults;
    }

    return stateFillDefaultsDiff;
}
